import React, { Component } from 'react';
import { Card, Col, message, Popover, Row, Spin } from 'antd';

import { queryFinanceBooksStatistics } from '@api/finance/finance';
import util from '@util';
import moment from 'moment';

class CardStatic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statistics: {},
      loading: false,
    };
  }

  componentDidMount() {
    const { uuid, beginDate, endDate } = this.props;
    this.loadStatistics(uuid, beginDate, endDate);
  }

  componentWillReceiveProps(nextProps) {
    const { changeFlag } = nextProps;
    if (changeFlag !== this.props.changeFlag) {
      this.loadStatistics(nextProps.uuid, nextProps.beginDate, nextProps.endDate);
    }
  }

  /**
   * 获取账号统计
   */
  loadStatistics = (uuid, beginDate, endDate) => {
    this.setState({ loading: true });
    queryFinanceBooksStatistics({
      uuid,
      beginDate: beginDate ? moment(beginDate).format('YYYY-MM-DD') : '',
      endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : '',
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({ statistics: res.data, loading: false });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { statistics, loading } = this.state;
    return (
      <Card className="description">
        <Row type="flex" justify="space-around" align="middle">
          <Col span={6}>
            <p style={{ marginBottom: '16px' }}>
              <span className="title">账户名称:</span>{' '}
              <span>{loading ? <Spin /> : statistics.accountName}</span>
            </p>
            <p>
              <span className="title">所属公司:</span>{' '}
              <span>{loading ? <Spin /> : statistics.companyName}</span>
            </p>
          </Col>
          <Col span={6}>
            <p style={{ marginBottom: '16px' }}>
              <span className="title">总收入:</span>
              <span>
                <Popover
                  title="总收入=非走账收入+走账收入"
                  content={`${util.numberFormat(statistics.incomeSum)}=${util.numberFormat(
                    statistics.incomeSumIgnoreNo,
                  )}+${util.numberFormat(statistics.incomeSumIgnore)}`}
                >
                  {loading ? <Spin /> : util.numberFormat(statistics.incomeSum, 2, '.', ',')}
                </Popover>
              </span>
            </p>
            <p>
              <span className="title">总支出:</span>
              <span>
                <Popover
                  title="总支出=非走账支出+走账支出"
                  content={`${util.numberFormat(statistics.expenditureSum)}=${util.numberFormat(
                    statistics.expenditureSumIgnoreNo,
                  )}+${util.numberFormat(statistics.expenditureSumIgnore)}`}
                >
                  {loading ? <Spin /> : util.numberFormat(statistics.expenditureSum, 2, '.', ',')}
                </Popover>
              </span>
            </p>
          </Col>
          <Col span={6}>
            <p style={{ marginBottom: '16px' }}>
              <span className="title">收入款项:</span>{' '}
              <span>
                <Popover
                  title="收入款项=非走账收入数+走账收入数"
                  content={`${statistics.incomeCount}=${statistics.incomeCountIgnoreNo}+${statistics.incomeCountIgnore}`}
                >
                  {loading ? <Spin /> : statistics.incomeCount}笔
                </Popover>
              </span>
            </p>
            <p>
              <span className="title">支出款项:</span>{' '}
              <span>
                <Popover
                  title="支出款项=非走账支出数+走账支出数"
                  content={`${statistics.expenditureCount}=${statistics.expenditureCountIgnoreNo}+${statistics.expenditureCountIgnore}`}
                >
                  {loading ? <Spin /> : statistics.expenditureCount}笔
                </Popover>
              </span>
            </p>
          </Col>
          <Col span={6}>
            <p style={{ marginBottom: '16px' }}>
              <span className="title">账户余额:</span>
            </p>
            <p>
              <span className="title">
                {loading ? <Spin /> : util.numberFormat(statistics.currentBalance, 2, '.', ',')}
              </span>
            </p>
          </Col>
        </Row>
      </Card>
    );
  }
}

export default CardStatic;



// WEBPACK FOOTER //
// ./src/components/finance/capital/detail/CardStatic.js